<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formdate from "@/router/views/FormComponet/formdate.vue";
import forminput from "@/router/views/FormComponet/forminput.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Drawer from "vue-simple-drawer";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import AnktAnketPaylas from "./AnktAnketPaylas.vue";
import AnktAnket from "@/models/AnktAnket";
import Swal from "sweetalert2";
import Formcombobox from "../FormComponet/formcombobox.vue";
export default {
  mixins: [Api, Sabit, AnktAnket],
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {

    Layout,
    Drawer,
    PageHeader,
    AddEdit,
    AnktAnketPaylas,
    formcombobox,
    formdate,
    Formcombobox,
    Treeselect,
    forminput
  },
  data() {
    return {
      title: this.$t("AnktAnket.Title"),
      items: [
        {
          text: this.$t("AnktAnket.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("AnktAnket.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "20",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      isLoading: true,
      loadingRequestCount: 0,
      DataUpdate: "",
      AddEdit: "",
      DosyaYolu: "",
      Baglanti: "",
      IframeHtml: "",
      GetMyAnkets: false,
      AnketId: "",
      SiteProtokol: window.location.protocol,
      SiteAdres: window.location.host,
      ComboBoxBirimid: [],
      ComboBoxUygulamaid: [],
      BirimTree: {},
      FilitrelemePenceresi: false,
      MenuRoleKontrol: false,
      AdminRole: false,
      Filter: {
        Birimid: "",
        Uygulamaid: "",
        Baslamatarihiilk: "",
        Baslamatarihison: "",
        Bitistarihiilk: "",
        Bitistarihison: "",
        Anketkapalimi: "",
        Onay: "",
        AnketBirimid: "",
        Baslik:""
      },
      YektiliBirimler: null
    };
  },
  validations: {
    Filter: {
      Birimid: {},
      Uygulamaid: {},
      Baslamatarihiilk: {},
      Baslamatarihison: {},
      Bitistarihiilk: {},
      Bitistarihison: {},
      Anketkapalimi: {},
      Onay: {},
      AnketBirimid: {},
      Baslik: {}
    },
  },
  watch: {
    isLoading() {
      this.hideLayoutLoader();
    },
  },
  methods: {
    startLoading() {
      this.loadingRequestCount += 1;
      this.isLoading = true;
    },
    finishLoading() {
      this.loadingRequestCount = Math.max(this.loadingRequestCount - 1, 0);
      this.isLoading = this.loadingRequestCount > 0;
    },
    withLoading(request) {
      this.startLoading();
      return request.finally(() => {
        this.finishLoading();
      });
    },
    hideLayoutLoader() {
      this.$nextTick(() => {
        const preloader = document.getElementById("preloader");
        const status = document.getElementById("status");
        if (preloader) preloader.style.display = "none";
        if (status) status.style.display = "none";
      });
    },
    MenuRoleControl() {
      let YetkiSorgu = this.UserRolles.filter(
        (item) =>
          item.includes("AnketTumAnketler") || item.includes("SuperAdmin") || item.includes("AnketOnay")
      );
      if (YetkiSorgu.length != 0) this.MenuRoleKontrol = true;

      let YetkiSorgu2 = this.UserRolles.filter(
        (item) =>
          item.includes("SuperAdmin") 
      );
      if (YetkiSorgu2.length != 0) this.AdminRole = true;
    },
    Onay(Data) {
      Data.Onay = true
      Data.Onayuserid = this.TokenUserId
      this.Update("AnktAnket", Data).then();
    },
    OnayIptal(Data) {
      Data.Onay = false
      Data.Onayuserid = this.TokenUserId
      this.Update("AnktAnket", Data).then();

    },

    Get() {
      this.MenuRoleControl();
      var TumAnketlerKontrol = false;
      let YetkiSorgu = this.UserRolles.filter(
        (item) =>
          item.includes("AnketTumAnketler") || item.includes("SuperAdmin")
      );
      if (YetkiSorgu.length != 0) TumAnketlerKontrol = true;

      var BirimAnketlerKontrol = false;
      YetkiSorgu = this.UserRolles.filter(
        (item) =>
          item.includes("AnketBirimAnketler")
      );
      if (YetkiSorgu.length != 0) BirimAnketlerKontrol = true;



      var Filter =
        "&Desc=created";
        if (this.GetMyAnkets == true ) {
        Filter = Filter + "&Createdby=" + this.TokenUserId
      }
      if (this.Filter.Birimid != null && this.Filter.Birimid != '') {
        Filter = Filter + "&Birimid=" + this.Filter.Birimid
      }
      if (this.Filter.Uygulamaid != null && this.Filter.Uygulamaid != '') {
        Filter = Filter + "&Uygulamaid=" + this.Filter.Uygulamaid
      }
      if (this.Filter.Baslamatarihiilk != null && this.Filter.Baslamatarihiilk != '') {
        Filter = Filter + "&Baslamatarihiilk=" + this.Filter.Baslamatarihiilk
      }
      if (this.Filter.Baslamatarihison != null && this.Filter.Baslamatarihison != '') {
        Filter = Filter + "&Baslamatarihison=" + this.Filter.Baslamatarihison
      }
      if (this.Filter.Bitistarihiilk != null && this.Filter.Bitistarihiilk != '') {
        Filter = Filter + "&Bitistarihiilk=" + this.Filter.Bitistarihiilk
      }
      if (this.Filter.Bitistarihison != null && this.Filter.Bitistarihison != '') {
        Filter = Filter + "&Bitistarihison=" + this.Filter.Bitistarihison
      }
      if (this.Filter.Anketkapalimi != null && this.Filter.Anketkapalimi != '') {
        Filter = Filter + "&Anketkapalimi=" + this.Filter.Anketkapalimi
      }
      if (this.Filter.Onay != null && this.Filter.Onay != '') {
        Filter = Filter + "&Onay=" + this.Filter.Onay
      }
      if (this.Filter.AnketBirimid != null && this.Filter.AnketBirimid != '') {
        Filter = Filter + "&Anketbirimid=" + this.Filter.AnketBirimid
      }
      if (!TumAnketlerKontrol) {
        Filter = Filter + "&Yetkilipersonelid=" + this.TokenUserId;
      }
      if (BirimAnketlerKontrol) {
        Filter += "&Birimanketlerinigorme=true"
      }

        if (this.Filter.Baslik != null && this.Filter.Baslik != '') {
        Filter = Filter + "&Baslik=" + this.Filter.Baslik
      }


      return this.withLoading(this.ActionsFilterGet({
        Service: "AnktAnket",
        Page: this.Page,
        Filter: Filter,
      })).then((res) => {
        this.FilitrelemePenceresi = false;
        this.TableData = res.Data || [];
        this.Page.PageDataSize = res.TotalCount || 0;

      });

    },
    CopyAnkt(Data) {
        const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      this.$delete(Data, "Id");
      Data.Onay = false;
      Data.Baslik = Data.Baslik + " " + moment().format("DD.MM.YYYY");
      Data.Created = today
      this.Post("AnktAnket", Data).then((res) => {
        if (res) {
          this.FormData = this.AnktAnketData;
        }
      });
    },
    IframeOlustur() {
      this.IframeHtml =
        '<iframe src="' +
        this.Baglanti +
        '" width="640" height="582" frameborder="0" marginheight="0" marginwidth="0">Yükleniyor…</iframe>';
    },
    DeleteAnkt(Servis, AnktId) {
      this.ActionsFilterGet({
        Service: "AnktAnketCevap",
        Page: this.Page,
        Filter: "&Anketid=" + AnktId,
      }).then((res) => {
        let AnketCevapKontrol = res.Data.length;
        Swal.fire({
          title: this.$t("ToasMessage.DeletePopupBaslik"),
          text:
            AnketCevapKontrol == 2
              ? this.$t("ToasMessage.DeletePopupContent")
              : this.$t("ToasMessage.DeletePopupContentAltKayitTrue"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
          cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
        }).then((result) => {
          if (result.value) {
            this.ActionsDelete({ Service: Servis, Id: AnktId }).then((res) => {
              if (res.Succeeded == true) {
                this.Get();
                this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
              } else {
                this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
              }
            });
          }
        });
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
  created() {
    this.DosyaYolu = this.$config.FILES_URL;
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.withLoading(this.ActionsGet({ "Service": "OBirim/GetTreeByAnaBirim", "Page": Page })).then(res => {

      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      let gelen_veri = JSON.stringify(res.Data);
      let silinecek = '"children":null,';
      gelen_veri = gelen_veri.replaceAll(silinecek, "");
      tumu[0].children = JSON.parse(gelen_veri);
      this.BirimTree = tumu;

    });
    this.withLoading(this.ActionsGet({ Service: "OBirim", Page: Page })).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxBirimid.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });
    this.withLoading(this.ActionsGet({ Service: "OUygulama", Page: Page })).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxUygulamaid.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Uygulamaadi,
        });
      }
    });
  },
  mounted() {
    this.hideLayoutLoader();
    setTimeout(() => {
      this.hideLayoutLoader();
    }, 0);
  },
};
</script>

<template>
  <div>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div v-if="isLoading" class="anket-loading-overlay">
        <b-spinner variant="primary" label="Yükleniyor"></b-spinner>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="">
            <div class="">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="GetMyAnkets = !GetMyAnkets, Get()" v-if="GetMyAnkets == false">
                      <i class="mdi mdi-swap-vertical"></i>
                      Oluşturduğum Anketleri Listele
                    </button>
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2"
                      @click="GetMyAnkets = !GetMyAnkets, Get()" v-if="GetMyAnkets == true">
                      <i class="mdi mdi-swap-vertical"></i>
                      Tüm Anketleri Listele
                    </button>
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer">
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("AnktAnket.Page.Filtreleme") }}
                    </button>
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.AnktAnket
                      @click="(DataUpdate = AnktAnketData), (AddEdit = 'Add')">
                      <i class="mdi mdi-plus me-1"></i>
                      {{ $t("AnktAnket.Page.YeniKayitEkle") }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- <div class="table-responsive">
                <table class="table table-sm mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="px-2">{{ $t("AnktAnket.Table.Baslik") }}</th>
                      <th class="px-2">{{ $t("AnktAnket.Table.Created") }}</th>
                      <th class="px-2">{{ $t("AnktAnket.Table.Baslamatarihi") }}</th>
                      <th class="px-2">{{ $t("AnktAnket.Table.Bitistarihi") }}</th>
                      <th class="px-2">{{ $t("AnktAnket.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody class="tabloAnket">
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Baslik }}</th>
                      <th scope="row">{{ Data.Created | formatDateTable }}</th>
                      <th scope="row">{{ Data.Baslamatarihi | formatDateTable }}</th>
                      <th scope="row">{{ Data.Bitistarihi | formatDateTable }}</th>
                      <td>
                        <i
                          v-tooltip="$t('AnktAnket.Table.Duzenle')"
                          class="fas fa-pencil-alt"
                          v-b-modal.AnktAnket
                          @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                        ></i
                        ><i
                          v-tooltip="$t('AnktAnket.Table.Sil')"
                          class="fas fa-trash-alt"
                          @click="DeleteAnkt('AnktAnket', Data.Id)"
                        ></i
                        >
                        <i
                          v-tooltip="$t('AnktAnket.Table.Kopyala')"
                          class="far fa-copy"
                          @click="CopyAnkt(Data)"
                        ></i>
                        
                        <a :href="'AnktForm/' + Data.Id"
                        v-if="Data.Disanketurl.trim() ==''"
                        >
                          <i
                            v-tooltip="$t('AnktAnket.Table.FormDuzenle')"
                            class="fas fa-edit"
                          ></i
                        ></a>

                        <a :href="'AnktDetay/' + Data.Id" v-if="Data.Disanketurl.trim() ==''">
                          <i v-tooltip="$t('AnktAnket.Table.Detay')" class="fab fa-wpforms"></i>
                        </a>
                        <i
                         v-if="Data.Disanketurl.trim() ==''"
                          v-tooltip="$t('AnktAnket.Table.Paylas')"
                          class="fas fa-share-alt"
                          v-b-modal.AnktAnketPaylas
                          @click="
                            (Baglanti = 
                              'http://'+SiteAdres+'/AnktAnketCevap/' +
                              Data.Id),
                              (AnketId = Data.Id),
                              IframeOlustur()
                          "
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
      <AnktAnketPaylas :Baglanti="Baglanti" :IframeHtml="IframeHtml" />

      <div class="row" v-if="TableData.length > 0">
        <template v-for="(Data, index) in TableData">
          <div :key="index" class="col-xl-12 col-sm-12">
            <div class="card" style="border-radius: 25px;">
              <div class="card-body">
                <div class="media anket-row" >
                  <div class="avatar-sm me-3 col-2 anket-icon">
                    {{ Data.BolumIcon }}
                    <span class="
                      avatar-title
                      rounded-circle
                      bg-light
                      text-danger
                      font-size-16
                    " :style="{
                      'background-image':
                        'url(' + DosyaYolu + Data.Filename + ')',
                    }" style="background-size: cover">
                    </span>
                  </div>
                  <div class="media-body overflow-hidden col-6 anket-body">
                    <h5 class="font-size-15 anket-title">
                      <a href="javascript: void(0);" class="text-dark">
                        {{ Data.Baslik }}
                      </a>
                    </h5>
                      <p class="text-muted">
                        {{ Data.Created | formatDateTable }} Tarihinde Oluşturuldu
                      </p>
                  </div>
                  <div class="px-3 col-2 anket-date">
                    <ul class="list-inline mb-0">
                      <li class="list-item me-3">
                        <div class="avatar-group">
                      <div class="list-inline">
                        <i class="bx bx-calendar me-1"></i>
                        {{ Data.Baslamatarihi | formatDateTable }}
                      </div>
                      <div class="list-inline">
                        <i class="bx bx-calendar me-1"></i>
                        {{ Data.Bitistarihi | formatDateTable }}
                      </div>
                    </div>
                      </li>                   
                  
                    </ul>
                  </div>
                  <div class="col-3 anket-birim">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item me-3 py-3">
                        <h6 class="font-size-12">
                      {{Data.birimadi}}
                    </h6>
                      </li>
                    
                  
                    </ul>
                  </div>
                  <div class="py-3 col-3 anket-actions" >
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item me-3" v-if="!Data.Anketkapalimi">
                        <i v-if="Data.Disanketurl.trim() == ''" v-tooltip="$t('AnktAnket.Table.Paylas')"
                          class="fas fa-share-alt" v-b-modal.AnktAnketPaylas @click="
                          (Baglanti =
                            SiteProtokol +
                            '//' +
                            SiteAdres +
                            '/AnktAnketCevap/' +
                            Data.Id),
                            (AnketId = Data.Id),
                            IframeOlustur()
                            "></i>
                      </li>

                      <li class="list-inline-item me-3">
                        <i v-tooltip="$t('AnktAnket.Table.Duzenle')" class="fas fa-pencil-alt" v-b-modal.AnktAnket
                          @click="(DataUpdate = Data), (AddEdit = 'Edit')"></i>
                      </li>

                      <li class="list-inline-item me-3">
                        <i v-tooltip="$t('AnktAnket.Table.Sil')" class="fas fa-trash-alt"
                          @click="DeleteAnkt('AnktAnket', Data.Id)"></i>
                      </li>

                      <li class="list-inline-item me-3">
                        <i v-tooltip="$t('AnktAnket.Table.Kopyala')" class="far fa-copy" @click="CopyAnkt(Data)"></i>
                      </li>

                      <li class="list-inline-item me-3">
                        <a :href="'AnktForm/' + Data.Id" v-if="Data.Disanketurl.trim() == ''">
                          <i v-tooltip="$t('AnktAnket.Table.FormDuzenle')" class="fas fa-edit"></i>
                        </a>
                      </li>

                      <li class="list-inline-item me-3">
                        <a :href="'AnktDetay/' + Data.Id" v-if="Data.Disanketurl.trim() == ''">
                          <i v-tooltip="$t('AnktAnket.Table.Detay')" class="fab fa-wpforms"></i>
                        </a>
                      </li>
                      <li class="list-inline-item me-3" v-if="MenuRoleKontrol">
                        <i v-if="!Data.Onay" @click="Onay(Data)" v-tooltip="$t('AnktAnket.Table.Onay')"
                          class="fas fa-check-double"></i>
                        <i v-if="Data.Onay" @click="OnayIptal(Data)" v-tooltip="$t('AnktAnket.Table.OnayIptal')"
                          class="fas fas fa-times"></i>
                      </li>
                    </ul>
                  </div>


                </div>
              </div>

            </div>
          </div>


        </template>
        <b-pagination class="pagination pagination-rounded justify-content-center mb-2" v-model="DefaultPage"
          :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
          @input="ChangePage(DefaultPage)"></b-pagination>
      </div>
      <div class="row" v-else-if="!isLoading">
        <div class="col-xl-12">
          <div class="alert alert-success" role="alert">
            {{ $t("AnktAnket.Table.KayitBulunamadi") }}
          </div>
        </div>
      </div>
      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("AnktAnket.Filtreleme.Title") }}
            </h5>
          </div>

          <div class="offcanvas-body">
            {{ $t("AnktAnket.Filtreleme.Content") }}

             <div class="mb-3">
              <forminput :FormDataType="{
                FieldName: 'Baslik',
                Field: 'input',
                FieldTitle: $t('AnktAnket.Filtreleme.Baslik'),
               
              }" :Value="Filter.Baslik" :v="$v.Filter.Baslik" @input="Filter.Baslik = $event" />
            </div>

            <div class="mb-3">
              <b-form-group label='Anket Birimi' label-for="text" style="width:27rem;">
                <treeselect :multiple="false" :options="BirimTree" placeholder="Seçiniz..."
                  v-model="Filter.AnketBirimid" />

              </b-form-group>
            </div>

            <div class="mb-3">
              <formcombobox :FormDataType="{
                FieldName: 'Uygulamaid',
                Field: 'combobox',
                FieldTitle: $t('AnktAnket.Filtreleme.Uygulamaid'),
                ComboDataArray: ComboBoxUygulamaid,
              }" :Value="Filter.Uygulamaid" :v="$v.Filter.Uygulamaid" @input="Filter.Uygulamaid = $event" />
            </div>
            <div class="mb-3">
              <formdate :FormDataType="{
                FieldName: 'Baslamatarihiilk',
                Field: 'date',
                FieldTitle: $t('AnktAnket.Filtreleme.Baslamatarihiilk'),
              }" :Value="Filter.Baslamatarihiilk" :v="$v.Filter.Baslamatarihiilk"
                @input="Filter.Baslamatarihiilk = $event" />
            </div>
            <div class="mb-3">
              <formdate :FormDataType="{
                FieldName: 'Baslamatarihison',
                Field: 'date',
                FieldTitle: $t('AnktAnket.Filtreleme.Baslamatarihison'),
              }" :Value="Filter.Baslamatarihison" :v="$v.Filter.Baslamatarihison"
                @input="Filter.Baslamatarihison = $event" />
            </div>
            <div class="mb-3">
              <formdate :FormDataType="{
                FieldName: 'Bitistarihiilk',
                Field: 'date',
                FieldTitle: $t('AnktAnket.Filtreleme.Bitistarihiilk'),
              }" :Value="Filter.Bitistarihiilk" :v="$v.Filter.Bitistarihiilk"
                @input="Filter.Bitistarihiilk = $event" />
            </div>


            <div class="col-sm-6 mt-2">
              <b-form-group label='Anket Uygulanacak Birimler' label-for="text" style="width:27rem;">
                <treeselect  :multiple="false" :options="BirimTree" placeholder="Seçiniz..." v-model="Filter.Birimid" />

              </b-form-group>
            </div>


            <div class="mb-3">
              <formdate :FormDataType="{
                FieldName: 'Bitistarihison',
                Field: 'date',
                FieldTitle: $t('AnktAnket.Filtreleme.Bitistarihison'),
              }" :Value="Filter.Bitistarihison" :v="$v.Filter.Bitistarihison"
                @input="Filter.Bitistarihison = $event" />
            </div>
            <div class="mb-3">
              <formcombobox :FormDataType="{
                FieldName: 'Anketkapalimi',
                Field: 'combobox',
                FieldTitle: $t('AnktAnket.Filtreleme.Anketkapalimi'),
                ComboDataArray: [
                  { Id: 'true', Value: 'Evet' },
                  { Id: 'false', Value: 'Hayır' },
                ],
              }" :Value="Filter.Anketkapalimi" :v="$v.Filter.Anketkapalimi" @input="Filter.Anketkapalimi = $event" />
              
            </div>
            <div class="mb-3" v-if="AdminRole">
              <formcombobox :FormDataType="{
                FieldName: 'Onay',
                Field: 'combobox',
                FieldTitle: $t('AnktAnket.Filtreleme.Onay'),
                ComboDataArray: [
                  { Id: 'true', Value: 'Onaylı' },
                  { Id: 'false', Value: 'Onaysız' },
                ],
              }" :Value="Filter.Onay" :v="$v.Filter.Onay" @input="Filter.Onay = $event" />
              
            </div>

            <b-button @click="Get" class="btn btn-primary" variant="primary">
              {{ $t("AnktAnket.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </div>
</template>
//
<style lang="scss" scoped>
// .tabloAnket tr th{
//   font-weight: 400 !important;
//   font-size: 12px !important;
// }
// .tabloAnket tr td i{
//   // background: rgb(209, 209, 209);
//   padding: 5px;
//   transition: all 0.4s ease-in-out 0s;
//   color: rgb(72, 94, 196);
//   cursor:pointer;
//   overflow-wrap: break-word;
// }
// .tabloAnket tr td i:not(:last-child){
//    margin-right: 2px;
//    margin-left: 2px;
// }
// .tabloAnket tr td a{
//    margin-right: 2px;
//   margin-left: 2px;
// }
// .tabloAnket tr td i:hover{
//   transform: scale(1.4);
//   background: rgb(72, 94, 196);
//   color: rgb(255, 255, 255) !important;
// }
// .tabloAnket tr:hover{
//   transition: all 0.4s ease-in-out 0s;
//   background: #f2f2f5;
// }
.list-inline-item a i,
.list-inline-item i {
  color: rgb(38, 38, 38);
  cursor: pointer;
}

.list-inline-item a i:hover,
.list-inline-item i:hover {
  color: rgb(22, 29, 117);
}

.anket-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
}

.anket-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}

/* ICON */
.anket-icon {
  flex: 0 0 60px;
}

/* BAŞLIK (EN GENİŞ ALAN) */
.anket-body {
  flex: 1;
  min-width: 0; /* text-truncate için şart */
}

/* TARİHLER */
.anket-date {
  flex: 0 0 170px;
  font-size: 12px;
}

/* BİRİM */
.anket-birim {
  flex: 0 0 200px;
  text-align: center;
}

/* AKSİYONLAR */
.anket-actions {
  flex: 0 0 200px;
  text-align: right;
}

</style>
